import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "../ScrollTrigger.js";
gsap.registerPlugin( ScrollTrigger);
import { log } from 'handlebars'



class  Magnet extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)

    this.ref = {

    }
  }


  mount() {

    // this.resizeQue = this.resize.bind(this)
    // stage.on("stage:resize", this.resizeQue);


    gsap.fromTo(".whypath", {
        opacity: 0,
        
        xPercent: 40,
        yPercent: -30
    }, {
        opacity: 1,
        xPercent: 0,
        yPercent: 0,
        stagger: .2,
        duration: 4,
        ease: 'elastic.out(1, 0.3)'
    })

    var indexes = [30, 20, 40, 11, 25, 16]

    _each($('.whypath'), (el, index) => {
      gsap.fromTo(el,

        {
          yPercent: 0,
          ease: "none"

        },

        {
          yPercent: indexes[index],
          ease: "none",
          scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "top top-=100%",
            scrub: 1
          },
        });
    })



    // this.magnetic = (el, magText = false) => {
    //     let target;
    //     let span;
    //     if (el.nodeType) {
    //         target = el;
    //     } else {
    //         target = document.querySelector(el);
    //     }

    //     const { left, top, height, width } = target.getBoundingClientRect();

    //     const magnetize = (val) => {
    //         const dist = gsap.utils.normalize(0, width, Math.abs(val));
    //         const interp = gsap.utils.interpolate([1, 0.96, 0], dist);
    //         return interp;
    //     };

    //     const enterEvent = (e) => {
    //         const mousePosition = { x: e.pageX, y: e.pageY };
    //         target.addEventListener("mousemove", moveEvent);
    //         target.addEventListener("mouseleave", leaveEvent);
    //     };

    //     const moveEvent = (e) => {
    //         const mousePosition = { x: e.pageX, y: e.pageY };
    //         const relX = mousePosition.x - left - width / 2;
    //         const relY = mousePosition.y - top - height / 2;
    //         const moveX = magnetize(relX);
    //         const moveY = magnetize(relY);
    //         gsap.to(target, {
    //         x: moveX * relX,
    //         y: moveY * relY
    //         });

            
    //     };

    //     const leaveEvent = (e) => {
    //         const mousePosition = { x: e.pageX, y: e.pageY };
    //         const relX = mousePosition.x - left - width / 2;
    //         const relY = mousePosition.y - top - height / 2;

    //         const dist = Math.sqrt(Math.pow(relX, 2) + Math.pow(relY, 2));

    //         const calcFactor = gsap.utils.pipe(
    //         gsap.utils.clamp(10, 270),
    //         gsap.utils.mapRange(10, 270, 0.8, 1.75)
    //         );
    //         const factor = calcFactor(dist);
    //         target.removeEventListener("mousemove", moveEvent);
    //         target.removeEventListener("mouseleave", leaveEvent);
    //         gsap.to(target, {
    //         x: 0,
    //         y: 0,
    //         ease: `elastic.out(${factor}, 0.5)`,
    //         duration: 1
    //         });

            
    //     };

    //      target.addEventListener("mouseenter", enterEvent);

    //      this.destroy = () =>{
    //         target.removeEventListener("mouseenter", enterEvent);
    //      }

    //      return this
    
    // };

    //     this.lo = this.magnetic("#lo", false);
    //     this.lu = this.magnetic("#lu", false);
    //     this.lr = this.magnetic("#lr", false);
    //     this.lw = this.magnetic("#lw", false);
    //     this.lh = this.magnetic("#lh", false);
    //     this.ly = this.magnetic("#ly", false);

        
   

  }

 

  render(e) {

  }

  unmount() {
    


  }

}

module.exports = Magnet
